import { dew as _AbstractTimeExpressionParserDew } from "../../../common/parsers/AbstractTimeExpressionParser";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const AbstractTimeExpressionParser_1 = _AbstractTimeExpressionParserDew();
  class ESTimeExpressionParser extends AbstractTimeExpressionParser_1.AbstractTimeExpressionParser {
    primaryPrefix() {
      return "(?:(?:aslas|deslas|las?|al?|de|del)\\s*)?";
    }
    followingPhase() {
      return "\\s*(?:\\-|\\\u2013|\\~|\\\u301C|a(?:l)?|\\?)\\s*";
    }
  }
  exports.default = ESTimeExpressionParser;
  //# sourceMappingURL=ESTimeExpressionParser.js.map
  return exports;
}